import PropTypes from 'prop-types'
import { useLocalization } from '@/hooks/localization'

const Rtl = (props) => {
  const { rtl } = useLocalization()
  return props.render(rtl)
}

Rtl.propTypes = {
  render: PropTypes.func.isRequired
}

export {
  Rtl
}



// WEBPACK FOOTER //
// ./src/components/rtl.js